<template>
  <b-overlay v-if="showLoaderOverlay" no-wrap fixed :z-index="10000" :show="true" rounded="sm">
    <template v-slot:overlay>
      <appLoader />
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: "LoaderOverlay",
  computed: {
    showLoaderOverlay() {
      return this.$store.state.showLoaderOverlay;
    },
  },
};
</script>
